// extracted by mini-css-extract-plugin
module.exports = {"container":"PrizesSection_container__8LvJc","textMaxWidth":"PrizesSection_textMaxWidth__qt18E","prizeCarouselContainer":"PrizesSection_prizeCarouselContainer__TNcz0"};